import React from 'react';

class ContactForm extends React.Component {
  constructor() {
    super();

    this.state = {
      from: '',
      subject: '',
      message: '',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();    
  }

  handleChange(e) {
    const key = e.target.id;
    this.setState({ [key]: e.target.value });
  }
  render() {
    const { from, subject, message } = this.state;
    return (
      <form onSubmit={this.handleSubmit}>
        <input id="from" placeholder="From email" value={from} onChange={this.handleChange} required />
        <input id="subject" placeholder="Subject" value={subject} onChange={this.handleChange} required />
        <textarea id="message" placeholder="Message" value={message} onChange={this.handleChange} required />
        <button type="submit">send</button>
      </form>
    );
  }
}

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/ContactForm/index.js